import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
    CircularProgress,
} from '@material-ui/core';
import AppBarModal from '../../../../general/AppBarModal';
import { BIENESTAR_MODAL_PAPER_FLEX } from '../../helpers/bienestarDetalleConstants';

const PAPER_PROPS = { style: BIENESTAR_MODAL_PAPER_FLEX };

/**
 * Elige el alcance del aviso de disentimiento cuando la solicitud tiene los dos
 * formatos disponibles (Crisis / Socioemocional): solo el normal, o normal +
 * Traslado EPS. Fuera de esos dos servicios el aviso se activa directo, sin
 * pasar por este diálogo.
 */
function DialogAvisoDisentimiento({ open, onClose, onConfirmar, enviando }) {
    const [incluirTrasladoEps, setIncluirTrasladoEps] = useState(false);

    useEffect(() => {
        if (open) setIncluirTrasladoEps(false);
    }, [open]);

    const cerrar = () => {
        if (enviando) return;
        if (typeof onClose === 'function') onClose();
    };

    return (
        <Dialog open={open} maxWidth="sm" fullWidth onClose={cerrar} PaperProps={PAPER_PROPS}>
            <AppBarModal titulo="¡ Aviso de disentimiento !" mostrarModal={cerrar} titulo_accion="" />
            <DialogContent>
                <Typography variant="body2" style={{ marginBottom: 12 }}>
                    ¿Qué disentimiento debe diligenciar el estudiante?
                </Typography>
                <RadioGroup
                    value={incluirTrasladoEps ? 'ambos' : 'normal'}
                    onChange={(e) => setIncluirTrasladoEps(e.target.value === 'ambos')}
                >
                    <FormControlLabel
                        value="normal"
                        control={<Radio color="primary" />}
                        label="Solo el disentimiento informado (normal)"
                        disabled={enviando}
                    />
                    <FormControlLabel
                        value="ambos"
                        control={<Radio color="primary" />}
                        label="Disentimiento informado + Traslado EPS"
                        disabled={enviando}
                    />
                </RadioGroup>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <Button onClick={cerrar} disabled={enviando}>Cancelar</Button>
                <div style={{ position: 'relative' }}>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => onConfirmar(incluirTrasladoEps)}
                        disabled={enviando}
                    >
                        Enviar aviso
                    </Button>
                    {enviando && (
                        <CircularProgress
                            size={24}
                            style={{ position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12 }}
                        />
                    )}
                </div>
            </DialogActions>
        </Dialog>
    );
}

export default DialogAvisoDisentimiento;
